module.exports = __webpack_public_path__ + "img/no-response.43e4333b.svg";